import { Moment } from 'moment';
import styled from 'styled-components';

export const CalendarDayText = styled.span.attrs({
  'data-datepicker-day-text': 'true',
})`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
`;

export const renderCalendarDay = (day: Moment) => (
  <CalendarDayText>{day.date()}</CalendarDayText>
);
